import Header from './components/Header';
import HeroSection from './components/HeroSection';
import SectionUpdates from './components/SectionUpdates';
import SectionTopics from './components/SectionTopics';
import SectionApp from './components/SectionApp';
import SectionContact from './components/SectionContact';
import SectionFAQ from './components/SectionFAQ';
import SectionIndex from './components/SectionIndex';
import SectionCards from './components/SectionCards';
import SectionMedia from './components/SectionMedia';
import SectionRanking from './components/SectionRanking';
import SectionAbout from './components/SectionAbout';
import SectionFeatures from './components/SectionFeatures';
import SectionCarousel from './components/SectionCarousel';
import SectionComments from './components/SectionComments';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <HeroSection />
        <SectionUpdates />
        <SectionTopics />
        <SectionApp />
        <SectionContact />
        <SectionFAQ />
        <SectionIndex />
        <SectionCards />
        <SectionMedia />
        <SectionRanking />
        <SectionAbout />
        <SectionFeatures />
        <SectionCarousel />
        <SectionComments />
      </main>
      <Footer />
    </div>
  );
}